export default {"src":"/_next/static/media/LYV.374fb4f4.svg","height":18,"width":18};